import { ProfileRequest } from '../request-models/profile-request.model';
import { omitUndefined } from './wire-value-utils';

/** The hub request body for `PUT /auth/profile`: only the allowlisted fields that are set. */
export function toProfileRequest(fields: ProfileRequest): ProfileRequest {
  return omitUndefined<ProfileRequest>({
    firstName: fields.firstName,
    lastName: fields.lastName,
    phone: fields.phone,
    dateOfBirth: fields.dateOfBirth,
    entityType: fields.entityType,
    entityName: fields.entityName,
    taxId: fields.taxId,
    address: fields.address,
    city: fields.city,
    state: fields.state,
    zipCode: fields.zipCode,
    latitude: fields.latitude,
    longitude: fields.longitude,
  });
}
